<template>
  <div v-if="visible" class="opening_hours_backdrop" @click.stop="onOverlayClick">
    <div class="opening_hours_dialog" role="dialog" aria-modal="true">
      <button type="button" class="opening_hours_close" aria-label="Cerrar" @click="close">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M6 6l12 12M18 6L6 18" stroke="#1A1A1A" stroke-width="2" stroke-linecap="round" />
        </svg>
      </button>

      <p class="opening_hours_title">{{ pointName }}</p>

      <div v-if="pointAddress" class="opening_hours_row">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M12 21s7-5.686 7-11a7 7 0 1 0-14 0c0 5.314 7 11 7 11" stroke="#1A1A1A" stroke-width="1.5"/>
          <circle cx="12" cy="10" r="2.5" stroke="#1A1A1A" stroke-width="1.5"/>
        </svg>
        <span>{{ pointAddress }}</span>
      </div>

      <div class="opening_hours_row opening_hours_status">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="9" stroke="#1A1A1A" stroke-width="1.5"/>
          <path d="M12 7v5.5l3.5 2" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <span :class="schedule.isOpenNow ? 'is-open' : 'is-closed'">{{ schedule.statusLabel }}</span>
      </div>

      <ul class="opening_hours_list">
        <li v-if="schedule.breakTime">
          <span>{{ schedule.breakTime.label }}</span>
          <span>{{ schedule.breakTime.hours }}</span>
        </li>
        <li v-for="day in schedule.days" :key="day.dayId" :class="{ 'is-today': day.isToday }">
          <span>{{ day.label }}</span>
          <span :class="{ 'is-closed': day.isClosed }">{{ day.hours }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getOpeningHours } from '@/utils/openingHours'

export default {
  name: 'OpeningHoursModal',
  props: {
    visible: { type: Boolean, default: false },
    point: { required: false, default: null },
  },
  computed: {
    // A favourite carries the point name in puntoScharffName; its `name` is the alias the user
    // gave the location, so the point's own name has to win.
    pointName() {
      const point = this.point || {}
      return point.puntoScharffName || point.PuntoScharffName ||
        point.Name || point.nombre || point.name || 'Punto Sharf'
    },
    pointAddress() {
      const point = this.point || {}
      return point.Address || point.address || point.direccion || ''
    },
    schedule() {
      return getOpeningHours(this.point)
    },
  },
  methods: {
    // Clicks are swallowed here: the lists behind the dialog close themselves on any outside click.
    onOverlayClick(event) {
      if (event.target === event.currentTarget) this.close()
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.opening_hours_backdrop {
  position: fixed;
  inset: 0;
  z-index: 1100;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.opening_hours_dialog {
  position: relative;
  width: 100%;
  max-width: 420px;
  max-height: 85vh;
  overflow-y: auto;
  padding: 24px;
  border-radius: 16px;
  background: #FFFFFF;
  text-align: left;
}

.opening_hours_close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #D0D0D0;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
}

.opening_hours_title {
  margin: 0 40px 16px 0;
  font-size: 20px;
  font-weight: 700;
  color: #1A1A1A;
}

.opening_hours_row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 0;
  font-size: 14px;
  color: #1A1A1A;
  border-top: 1px solid #EDEDED;
}

.opening_hours_row svg { flex-shrink: 0 }

.opening_hours_status .is-open { font-weight: 700; color: #00A88F }
.opening_hours_status .is-closed { font-weight: 700; color: #B20000 }

.opening_hours_list {
  list-style: none;
  margin: 0;
  padding: 0 0 0 32px;
}

.opening_hours_list li {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 4px 0;
  font-size: 14px;
  color: #1A1A1A;
}

.opening_hours_list li span:last-child { color: #737373 }
.opening_hours_list li.is-today { font-weight: 700 }
.opening_hours_list li.is-today span:last-child { color: #1A1A1A }
.opening_hours_list .is-closed { color: #A0A0A0 }
</style>
